var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("HeaderLanding"),
      _vm._v(" "),
      _c(
        "b-container",
        {
          staticClass: "mt-5 mb-5",
          staticStyle: { "min-height": "65vh" },
          attrs: { fluid: "" }
        },
        [
          _c(
            "b-row",
            {
              staticStyle: { "margin-bottom": "40px" },
              attrs: { "align-h": "center" }
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c("font-awesome-icon", {
                    staticClass: "text-success my-auto success-icon",
                    attrs: { icon: ["fas", "check-circle"] }
                  }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "font-weight-bolder mt-3" }, [
                    _vm._v("Email Verified!")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-bottom": "55px" } }, [
                    _vm._v(
                      "You have successfully verified your email. Please log in to your account to continue."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-block",
                      attrs: { href: "/#/login" }
                    },
                    [_vm._v("Log In")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("FooterLanding")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b8e5ef7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b8e5ef7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/VerificationEmail.vue
// module id = null
// module chunks = 